/**
 * Check if the given data is a valid string.
 *
 * @param {Any} data
 * @return {Boolean}
 */
export const isString = (data: any) => typeof data === 'string';

/**
 * Check if the given data is null.
 *
 * @param {Any} data
 * @return {Boolean}
 */
export const isNull = (data: any) => data === null;

/**
 * Check if the given data is function.
 *
 * @param {Any} data
 * @return {Boolean}
 */
export const isFunc = (data: any) => typeof data === 'function';

/**
 * Check if the given data is not undefined.
 *
 * @param {Any} data
 * @return {Boolean}
 */
export const isNotUndefined = (data: any) => typeof data !== 'undefined';
